/** @format */

import { CriteoViewProductsResponse } from '@shared/data-access/interfaces';

/**
 * Used to initialize or reset the setCriteoProducts state to allow the
 * plp product list effect to run without making a call to Criteo.
 */
export const EMPTY_CRITEO_VIEW_PRODUCTS_RESPONSE: CriteoViewProductsResponse = {
	OnLoadBeacon: '',
	placements: [
		{
			carousel: [
				{
					OnClickBeacon: '',
					OnLoadBeacon: '',
					OnViewBeacon: '',
					format: '',
					rendering: '',
					products: []
				}
			]
		},
		{
			inGrid: [
				{
					OnClickBeacon: '',
					OnLoadBeacon: '',
					OnViewBeacon: '',
					format: '',
					rendering: '',
					products: []
				}
			]
		}
	]
};
